<template>
  <el-dialog title="选择模板" :visible="true" width="1250px" center @close="dialogClose">
    <div v-loading="fromLoading" class="activeEdit_bottom">
      <!-- 导航切换 -->
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          :label="item.groupName"
          :name="`index${index}`"
          v-for="(item, index) in navList"
          v-show="item.frontHide == 0"
          :key="item.id"
        ></el-tab-pane>
      </el-tabs>
      <div style="display:flex;align-items: center;" v-if="activeName == 'index0' && activityDataID == 25">
        <span style="color:red">*</span>海报类型：
        <el-select v-model="optionsValue" placeholder="请选择" @change="handleChangeOption">
          <el-option v-for="item in options" :key="item.id" :label="item.groupName" :value="item.id" v-show="item.frontHide == 0"> </el-option>
        </el-select>
      </div>
      <div class="itemList">
        <div v-if="activeName == 'index2' && activityDataID == 25">
          <el-form :model="objectForm" ref="ruleForm" class="backgroundForm" label-width="100px">
            <el-form-item label="上传图片:" required>
              <div style="display:flex">
                <el-upload
                  ref="upload"
                  action="#"
                  class="upload-new"
                  list-type="picture-card"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :http-request="httpRequest"
                  :file-list="fileList"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <el-dialog :visible.sync="dialogVisible" style="z-index:3050">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
                <div style="margin-left:20px;line-height:2">
                  <p>建议上传尺寸：662px * 588px</p>
                  <p>图片大小：300K以内</p>
                  <p>格式：jpg、png</p>
                </div>
                <!-- <span style="color: #7B61FF; font-size: 12px">建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span> -->
              </div>
            </el-form-item>
            <el-form-item label="图片名称:" required>
              <el-input v-model="objectForm.name" maxlength="15" show-word-limit style="width: 400px"></el-input>
              <div>若不设置则使用上传的图片文件名</div>
            </el-form-item>
          </el-form>
          <div style="width:1100px;text-align: right;margin-top:210px">
            <el-button class="returnBtn" size="medium" @click="dialogClose()">取消</el-button>
            <el-button class="keepBtn" type="primary" size="medium" @click="nextStepKai1()">确定</el-button>
          </div>
        </div>
        <div class="item" v-else>
          <div class="wrapper-kaika">
            <!-- 品牌定制 -->
            <div @click="handleOpen()" class="wrapper-kaika-img pointer">
              <div class="borderkaika" style="width: 100%;height: 100%;top:0;left:0;"></div>
              <div style="margin-top: 97px;">
                <img style="height: 32px;" src="@/assets/thdImg/pages/dz.svg" alt="" />
                <div>品牌定制</div>
              </div>
              <!-- hover -->
              <div class="temImg_content_bgshadow1" style="border-radius: 8px;" @click="handleOpen()">
                <div class="temImg_content_bgshadow1_codeDZ1">
                  <img style="width:100%" src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/wximg.png" alt="">
                </div>
              </div>
            </div>
            <!-- 礼包模板 -->
            <!-- 235 419 -->
            <div class="wrapper-kaika-img wrapperBg" v-for="item in giftList" :key="item.id">
              <div class="borderkaika"></div>
              <div class="wrapper-kaika-tanchuang imgMaxheight" style="padding: 4px 4px;height: 220px">
                <img style=" width: 200px; max-height: 200px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%); " :src="item.imageUrl" alt="" />
              </div>
              <div style="position: absolute;top:225px;text-align: left;">
                <div style="font-size: 14px;color:#333333;font-weight: 400;margin-left:12px;">模板名称：{{ item.imageName }}</div>
                <div style="font-size: 12px;color:#999999;font-weight: 400;margin-top:5px;margin-left:12px;">模板ID：{{ item.id }}</div>
              </div>
     

              <!-- <div v-if="item.expirationType" style="position: absolute;bottom: -11px;width: 100%;color: red;font-size: 12px;">
              <span style="left: 10px;position: absolute;font-weight: 500;">限免</span>
              <span style="right: 10px;position: absolute;font-weight: 500;">倒计时：{{ item.days }}</span>
            </div> -->
              <div class="mask">
                <div class="img">
                  <div class="imgBg">
                    <div class="qrCodeIMG" :id="`queryIdIMG${item.id}`" :ref="`queryIdIMG${item.id}`"></div>
                  </div>
                  <span class="tpl">手机扫码预览模板</span>
                </div>
                <div>
                  <el-button type="primary" size="medium" @click="nextStepKai(item)" style="width: 98px;height:30px">选择模板</el-button>
                </div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <!-- <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="recordData.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="recordData.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="recordData.total"
            class="pagination"
          >
          </el-pagination> -->
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import { zdImage, uploadpic, getSystemTemplateGroup, sellerImage } from "@/api/paradiseAndTaskCommonController.js";
export default {
  props: {
    // giftList: {
    //   type: Array,
    //   default: [],
    // },
    activityDataID: {},
  },
  data() {
    return {
      fromLoading: false,
      activeName: "index0",
      giftPopup: false,
      navList: [],
      tabActive: 0,
      giftList: [],
      options: [],
      optionsValue: "-1",
      recordData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      fileList: [],
      objectForm: {
        logo: "",
        name: "",
      },
    };
  },
  async created() {
    this.fromLoading = true;
    // const num = this.activityDataID == 25 ? 1 : 2;
    const num = this.activityDataID == 25 ? 1 : this.activityDataID == 32 ? 3:2;
    const GiftBag = await getSystemTemplateGroup({ smartCardType: num });

    if (this.activityDataID == 26 || this.activityDataID == 32) {
      this.navList = GiftBag.data;
      this.navItem = GiftBag.data[0];
    } else {
      this.navList = [
        {
          groupName: "系统模板",
          frontHide: 0,
          id: 1,
        },
        {
          groupName: "自定义",
          frontHide: 0,
          id: 2,
        },
        {
          groupName: "上传模板",
          frontHide: 0,
          id: 3,
        },
      ];
      let obj = {
        frontHide: 0,
        groupName: "全部",
        id: "-1",
        type: 1,
      };
      this.options = [obj, ...GiftBag.data];
      this.navItem = obj;
    }

    if (this.navList.length > 0) this.getPolite();
    if (this.navList.length == 0) this.fromLoading = false;
  },
  methods: {
    // handleNav(item, index) {
    //   this.tabActive = index;
    //   this.navItem = item;
    //   this.getPolite();
    // },
    handleChangeOption(val) {
      console.log(val);
      this.getPolite();
    },
    async getPolite() {
      this.fromLoading = true;
      let obj = {
        current: this.recordData.current,
        size: this.recordData.size,

        // source: this.activityDataID == 25 ? 2 : 3,
        source: this.activityDataID == 25 ? 2 : this.activityDataID == 32 ? 5 : 3,
      };
      if (this.activityDataID == 26 || this.activityDataID == 32) {
        obj.templateGroupId = this.navItem.id;
      }
      if (this.activityDataID == 25) {
        obj.type = this.activeName == "index0" ? 1 : 2;
        obj.templateGroupId = this.optionsValue == "-1" ? "" : this.optionsValue;
      }
      const { data } = await sellerImage(obj);
      this.recordData.total = data.total * 1;
      this.giftList = data.records;
      this.fromLoading = false;

      // if (this.activityDataID == 13) {
      //   this.giftList = giftList.filter((i) => i.giftType == 0);
      // }
      this.$nextTick(() => {
        // this.giftList.forEach((item) => {
        //   let ref = "queryIdIMG" + item.id;
        //   this.$refs[ref].innerHTML = "";
        // });

        this.getCodeIMG();
      });
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = fileList;

        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.objectForm.logo = res.data;
        });
      }
    },
    httpRequest() {},
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.imageName = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // 分页查询事件
    handleSizeChange(val) {
      this.recordData.size = val;
      this.getPolite();
    },
    handleCurrentChange(val) {
      this.recordData.current = val;
      this.getPolite();
    },
    handleClick(tab) {
      console.log(tab);
      if (this.activityDataID == 26 || this.activityDataID == 32) {
        this.navItem = this.navList[tab.index];
        this.getPolite();
      } else {
        this.navItem = this.navList[tab.index];
        this.optionsValue = "-1";
        if (this.navItem.id != 3) this.getPolite();
        if (this.navItem.id == 3) {
          this.fileList = [];
          this.objectForm.logo = "";
          this.objectForm.name = "";
        }
      }
    },

    nextStepKai(item) {
      this.$emit("handleChoice", item);
    },
    nextStepKai1() {
      let item = {
        id: "",
        imageUrl: this.objectForm.logo,
      };
      if (!this.objectForm.logo) {
        return this.$message.warning("请上传图片");
      }
      zdImage({
        imageUrl: this.objectForm.logo,
        imageName: this.objectForm.name ? this.objectForm.name : this.fileList[0].name,
        type: 2,
        source: 2,
      });
      this.$emit("handleChoice", item);
    },
    dialogClose() {
      this.$emit("handleChoice");
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // console.log(codeImg, 66666666);
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        element.innerHTML = "";
      }
      const url = `https://yq-hd-rc.isvjcloud.com/preview?source=${this.activityDataID}&activityId=''&venderId=${this.$store.state.loginUserInfo.venderId}`;
      for (let index = 0; index < codeImg.length; index++) {
        console.log(this.giftList[index],'this.giftList[index]')
        const element = codeImg[index];
        if(this.activityDataID == 32) {
          new QRCode(element, {
            width: 106, // 设置宽度，单位像素
            height: 106, // 设置高度，单位像素
            // text: url, // 设置二维码内容或跳转地址
            text: `https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=${this.giftList[index].thankImageUrl}`,
          });
        }else{
          new QRCode(element, {
            width: 106, // 设置宽度，单位像素
            height: 106, // 设置高度，单位像素
            // text: url, // 设置二维码内容或跳转地址
            text: `${url}&srcImg=${this.giftList[index].imageUrl}`,
          });
        }

      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  margin-top: 9vh !important;
}
.activeEdit_bottom {
  max-height: 73vh;
  overflow-y: auto;
}
.imgMaxheight {
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  left: 50%;
  transform: translateX(-50%);
  padding-top: 74px;
  box-sizing: border-box;
  background: #74757A;
  padding: 56px 4px;
  border-radius: 9px 9px 0 0;
  width: 100%;
}
.upload-new {
  /deep/.el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 113px;
  }
}
.pagination {
  text-align: right;
  position: absolute;
  right: 0;
  bottom: 0;
}
.itemList {
  display: flex;
  min-height: 400px;
  .item {
    width: 100%;
    flex: 1;
    box-sizing: border-box;
    position: relative;
    color: #666;
    text-align: center;
    padding: 6px;
    &:hover {
      .border::before,
      .border::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .border {
      position: absolute;
      left: 0;
      top: 0;
      // width: 100%;
      height: 100%;
      width: 253px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #7b61ff;
        border-bottom: 1px solid #7b61ff;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #7b61ff;
        border-left: 1px solid #7b61ff;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    .wrapper-kaika {
      width: 100%;
      // height: 100%;
      display: grid;
      margin-bottom: 30px;
      // align-items: center;
      // justify-content: center;

      &-img {
        background-color: #fafafa;
        // border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
        border: 1px solid #e7e7e7;
        border-radius: 8px;
        // height: 350px;
        margin-right: 20px;
        box-sizing: content-box;
        position: relative;
        &:hover {
          .borderkaika::before,
          .borderkaika::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .borderkaika {
          position: absolute;
          left: -6px;
          top: -6px;
          width: 226px;
          height: 279px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #7b61ff;
            border-bottom: 1px solid #7b61ff;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #7b61ff;
            border-left: 1px solid #7b61ff;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        div {
          font-size: 18px;
          font-weight: bold;
          // line-height: 25px;
          color: #333333;
        }
        img {
          width: 32px;
          // height: 32px;
        }

        .queryIdIMG {
          display: none;
        }
        &:hover {
          .queryIdIMG {
            display: block;
          }
          .mask {
            opacity: 1;
          }
        }
        .mask {
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.6);
          color: #fff;
          opacity: 0;
          transition: all 0.2s;
          height: 100%;
          border-radius: 6px;
          .img {
            max-width: 130px;
            margin: 0 auto 5px;
            .imgBg {
              box-sizing: border-box;
              height: 116px;
              width: 116px;
              padding: 5px;
              border-radius: 6px;
              background-color: #fff;
            }
            .tpl {
              display: inline-block;
              font-size: 12px;
              color: #fff;
              margin-top: 7px;
              // opacity: 0.7;
            }
          }
          .mask-gift {
            position: absolute;
            bottom: 3px;
            width: 100%;
            div {
              text-align: center;
              color: #ffffff !important;
              font-size: 12px !important;
              opacity: 0.7;
              font-weight: 500 !important;
              line-height: 19px;
            }
          }
        }
      }
      &-tanchuang {
        position: absolute;
        // top: 50%;
        // top: 35%;
        // left: 50%;
        // transform: translate(-50%, -50%);
      }
      &-bottom {
        width: 102%;
        height: 30px;
        background: #ffffff;
        border: 1px solid #e7e7e7;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        color: #666 !important;
        position: absolute;
        bottom: -4px;
        left: -2px;
        line-height: 30px;
        font-size: 14px !important;
        text-align: left;
        padding-left: 10px;
        font-weight: 500 !important;
      }
      .lijijq {
        &::after {
          content: "立即领取";
          display: block;
          position: absolute;
          bottom: 9px;
          left: 51%;
          transform: translateX(-50%);
          font-size: 14px;
          font-family: system-ui;
          font-weight: bold;
          color: #ed6e09;
          text-shadow: 0 0 black;
        }
      }
    }
    .wrapper {
      position: relative;
      height: 350px;
      border-radius: 6px;
      overflow: hidden;
      display: grid;
      .queryId {
        display: none;
      }
      &:hover {
        .queryId {
          display: block;
        }
        .mask {
          opacity: 1;
        }
      }
      .mask {
        width: 210px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        opacity: 0;
        transition: all 0.2s;
        .img {
          max-width: 130px;
          margin: 0 auto 30px;
          .imgBg {
            box-sizing: border-box;
            height: 106px;
            width: 106px;
            padding: 5px;
            border-radius: 6px;
            background-color: #fff;
          }
          .tpl {
            display: inline-block;
            margin-top: 10px;
            color: #fff;
            // opacity: 0.7;
          }
        }
      }
    }
  }
}
.wrapper-kaika-img {
  width: 214px;
  height: 268px;
  margin-bottom: 40px;
  position: relative;
  &:hover .temImg_content_bgshadow1 {
    opacity: 0;
    animation: key3 0.5s forwards;
  }
  .temImg_content_bgshadow1 {
    z-index: 123;
    opacity: 0;
    position: absolute;
    left: 6px;
    top: 5px;
    width: 205px;
    height: 257px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 8px 8px 0px 0px;
    transform: scale(1.05);
    &_codeDZ1 {
      margin: 0 auto;
      margin-top: 20px;
      width: 148px;
      border-radius: 4px;
      padding: 5px;
    }
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
</style>
